import { render, staticRenderFns } from "./RemoveVotes.vue?vue&type=template&id=56853170&scoped=true&"
import script from "./RemoveVotes.vue?vue&type=script&lang=js&"
export * from "./RemoveVotes.vue?vue&type=script&lang=js&"
import style0 from "./RemoveVotes.vue?vue&type=style&index=0&id=56853170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56853170",
  null
  
)

export default component.exports